export default "__VITE_ASSET__H30VcNlX__"